export default __webpack_public_path__ + "static/energypark-fa6cb8a4bbf62f842a069f2f876accdd.jpg";